<template>
  <section class="sub_contents_wrap container">
    <div class="management_top_box">
      <h4>{{ $t("management.emailTemplate") }}</h4>
    </div>
    <div class="brick_box">
      <table class="write_tbl responsive_tbl">
        <tbody>
          <tr>
            <th>{{ $t("common.title") }}</th>
            <td>
              <input
                type="text"
                id="title"
                name="title"
                v-model="template.title"
                class="int_type01"
              />
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <ckeditor
                class="textarea_type"
                name="content"
                v-model="template.content"
                :config="editorConfig"
                v-validate="'required'"
                rows="15"
              ></ckeditor>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="list_bottom_bt">
        <router-link
          to="/management/email/template"
          class="btn btn-outline-dark btn-lg m-1"
          >{{ $t("common.list") }}</router-link
        >
        <button type="button" @click="saveTemplate" class="btn btn-primary btn-lg m-1">
          {{ $t("common.save") }}
        </button>
        <button
          type="button"
          @click="deleteTemplate"
          class="btn btn-secondary btn-lg m-1"
        >
          {{ $t("common.delete") }}
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import { getEmailTemplateDetail, saveTemplate, deleteTemplate } from "@/api/mail";

export default {
  data() {
    return {
      editorConfig: {
        toolbar: {
          items: [
            "heading",
            "|",
            "bold",
            "italic",
            "link",
            "undo",
            "redo",
            "bulletedList",
            "numberedList",
          ],
        },
      },
      template: { crudType: "I" },
      templateId: "",
      confirmYN: false,
    };
  },
  mounted() {
    if (this.$route.params.templateId != undefined) {
      this.fetchData();
    }
  },
  methods: {
    async fetchData() {
      try {
        this.templateId = this.$route.params.templateId;
        const { data } = await getEmailTemplateDetail(this.templateId);
        this.template = data.template;
        this.template.crudType = "U";
        console.log(this.template);
      } catch (err) {
        console.log(err);
      }
    },
    async saveTemplate() {
      const validForm = await this.$validator.validateAll();
      if (!validForm) return alert(this.$t("alert.plzCheckAllValues"));
      try {
        const { data } = await saveTemplate(this.template);
        if (data.message != null) {
          alert(this.$t("alert.plzCheckAllValues"));
        }
        if (data.status) {
          alert(this.$t("alert.savedSuccessfully"));
          this.$router.push("/management/email/template");
        } else {
          alert(this.$t("alert.ErrorPlzcontactManager"));
        }
      } catch (err) {
        console.log(err);
      }
    },
    async deleteTemplate() {
      this.confirmYN = confirm(this.$t("alert.delete"));
      if (this.confirmYN) {
        try {
          const { data } = await deleteTemplate(this.template);
          if (data.status) {
            alert(this.$t("alert.deletedSuccessfully"));
            this.$router.push("/management/email/template");
          } else {
            alert(this.$t("alert.ErrorPlzcontactManager"));
          }
        } catch (err) {
          console.log(err);
        }
      } else {
        return;
      }
    },
  },
};
</script>

<style></style>
